import { FallbackContainer, FallbackText } from "./CommentsFallback.styles";
import React from "react";
import { FaceMonocleIcon } from "@icons/FaceMonocleIcon";

export function CommentsFallbackOwnPost() {
    return (
        <FallbackContainer>
            <FaceMonocleIcon
                height="64px"
                width="64px"
                fill="var(--community-header-background-color)"
            />
            <FallbackText>
                Noch ruhig hier. Der erste Kommentar lässt nicht lange auf sich
                warten.
            </FallbackText>
        </FallbackContainer>
    );
}
